<template>
        <div class="table__responsive">
            <table class="table table__responsive">
                <thead v-if="!loadingDocuments && documents.length">
                    <tr>
                        <th>{{$t('dashboard.documents.table.header.document')}}</th>
                        <th class="table__cell--icon"></th>
                        <th class="table__cell--icon"></th>
                        <th class="table__cell--icon"></th>
                        <th class="table__cell--icon"></th>
                        <th class="table__cell--icon"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="loadingDocuments" :key="'loading'" class="table--loading">
                        <td colspan="5">
                            <div class="spinner"></div>
                            <div class="text-center loading_text">{{$t('dashboard.documents.table.loading')}}</div>
                        </td>
                    </tr>
                    <tr v-if="!loadingDocuments && !documents.length" :key="'no-documents'" class="table--empty">
                        <td colspan="5">
                            <div class="text-center">{{$t('dashboard.documents.table.no_documents')}}</div>
                        </td>
                    </tr>
                    <template v-if="documents.length">
                        <tr v-for="document in documents" :key="document.id">
                            <td style="max-width: 4rem;">{{ lastVersion(document).name }}</td>
                            <td>
                                <span v-tooltip.bottom="documentTooltipContent(document)" class="table__icon icons icon-info"></span>
                            </td>
                            <td>
                                <span @click="showVersions(document)"
                                    v-tooltip.bottom="$tc('dashboard.documents.table.historic_documents', versionCount(document), { count: versionCount(document) })"
                                    class="table__icon icons icon-clock"></span>
                            </td>
                            <td>
                                <span @click="showReturnedDocuments(document)"
                                    v-tooltip.bottom="$tc('dashboard.documents.table.return_documents', document.returns.length, { count: document.returns.length })"
                                    class="table__icon icons icon-layers">
                                </span>
                            </td>
                            <td><span @click="downloadDocument(document)" v-tooltip.bottom="$t('dashboard.documents.table.download')" class="table__icon icons icon-cloud-download"></span></td>
                            <td><span @click="showDeleteDocumentModal(document)" v-tooltip.bottom="$t('dashboard.documents.table.delete')" class="table__icon icons icon-trash"></span></td>
                        </tr>
                    </template>
                    <tr class="table__navigation" v-if="documentsMeta && documentsMeta.last_page > 1">
                        <td colspan="5">
                            <pagination :meta="documentsMeta" @goToPage="goToPage"/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import { saveFile } from '@/helpers';
    import Pagination from '@/components/tables/Pagination';
    import { GET_DOCUMENTS } from '@/store/modules/documents';

    @Component({
        components: {
            Pagination,
        }
    })
    export default class DocumentsTable extends Vue {
        name = 'documents-table';

        created() {
            this.$store.dispatch(GET_DOCUMENTS, {});
        }

        get documents() {
            // In the event there is an error during creation of a document it may not get any versions set.
            // There is not enough data on the object to then properly display it, so we filter those out.
            return this.$store.state.documents.documents.filter(doc => doc.versions.length);
        }

        get loadingDocuments() {
            return this.$store.state.documents.loading;
        }


        get documentsMeta() {
            return this.$store.state.documents.documentsMeta;
        }

        goToPage(pageNo) {
            this.$store.dispatch(GET_DOCUMENTS, { params: { page: pageNo }});
        }

        lastVersion(document) {
            return document.versions[document.versions.length - 1];
        }

        versionCount(document) {
            return document.versions.length - 1;
        }

        documentTooltipContent(document) {
            let infoData =  {
                sender: document.creator.name,
                date: this.$options.filters.formatDate(document.created_at),
                action: document.trajectory_file_action.name,
                category: document.trajectory_file_type.name
            };
            return this.$t('dashboard.documents.table.document_info', infoData);
        }

        showReturnedDocuments(document) {
            this.$modal.show('returned-documents-modal', { document });
        }

        showVersions(document) {
            this.$modal.show('document-versions-modal', { document });
        }

        downloadDocument(document) {
            let version = this.lastVersion(document);
            let URL = `trajectories/${this.$store.state.trajectory.trajectory.id}/files/${document.id}/versions/${version.id}/download`;
            return this.axios.get(URL, {responseType: 'blob'})
                .then(
                    res => saveFile(res.data, version.name, version.mime),
                    err => this.$notify.error(this.$t('notify.download_errror')));
        }

        showDeleteDocumentModal(document) {
            const content = {
                title: this.$t('modals.delete_document.title'),
                message: this.$t('modals.delete_document.message'),
            };
            this.$modal.show('confirmation-modal', { content, callback: this.deleteDocument, document});
        }

        deleteDocument({document}) {
            document.remove()
                .then(() => {
                    this.$notify.success(this.$t('notify.document.delete_success'));
                    this.$store.dispatch(GET_DOCUMENTS, {});
                })
                .catch(err => this.$notify.error(this.$t('notify.document.delete_error')));
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/tables/dashboard/DocumentsTable.vue